export enum PaymentEnum {
  Mensuel = 'Mensuel',
  Trimestriel = 'Trimestriel',
  Annuel = 'Annuel',
}

export enum EcheancePrelevementNumber {
  Mensuel = 1,
  Trimestriel = 2,
  Annuel = 3,
}
